/* eslint-disable */
export default {
    data() {
        return {
            responseCollapse: true
        }
    },
    computed: {
        commonParams() {
            const { appId: webappId, workspaceId } = this.$route.params
            return {
                webappId, workspaceId,
            }
        },
    },
   
}
